import React from 'react'

export const CtrContext = React.createContext({})

export default function CtrContextProvider({ value, children }) {
  return <CtrContext.Provider value={value}>{children}</CtrContext.Provider>
}
